import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { NotificationService } from '../_services/notification.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private notificationService:NotificationService,
        private authService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if(!this.authService.isLoggedIn()) {
            // not logged in so redirect to login page with the return url
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        else
        {
            let user_role = this.authService.user_dept;
            if (!user_role) {
                // Validate Token On Refresh
                this.authService.validate_token().subscribe(data=> {
                    if(data['status']) {
                        this.authService.bindNavbar(data['user']);
                        user_role = this.authService.user_dept;
                        // redirect to refresh url 
                        this.router.navigate([state.url]);
                        console.log('After Validation: ', user_role);
                    }
                    else {
                        // Invalid Token Found, Remove Token and redirect to login page with the return url
                        localStorage.removeItem('dschool_id_token');
                        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                        return false;
                    }
                });
            }
            else
            {
                if(route.data.page=='main-dashboard') {
                    return true;
                }
                
                // Check Role Base Authenticaion
                if (route.data.roles && route.data.roles.indexOf(user_role) !== -1) {
                    return true;
                }
    
                // Check Page Base Authentication
                var user_page_access_list = [
                        'restaurant', 'orders', 'customers', 
                        'menu-items', 'order-status', 'instructor'
                    ];
    
                if(user_page_access_list.indexOf(route.data.page)  !== -1 ) {
                    if (route.data.roles) {
                        if(route.data.roles.indexOf(user_role) !== -1){
                            return true;
                        }
                        else
                        {
                            this.notificationService.warn('Permission Denied!!');
                            // role not authorised so redirect to home page
                            this.router.navigate(['/']);
                            return false;
                        }
                    }
                    else {
                        return true;
                    }
                }
            
                // role not authorised so redirect to home page
                this.router.navigate(['/']);
                this.notificationService.warn('Permission Denied!!');
                return false;
            }
        }

            




        // //console.log(route.data.roles);
        // let user_role = this.authService.user_dept;
        // console.log(user_role);
        // if (!user_role) 
        // {
        //     // Validate Token On Refresh
        //     this.authService.validate_token().subscribe(data=> {
        //         console.log(data);
        //         if(data['status']) {
        //             this.authService.bindNavbar(data['user']);
        //             user_role = this.authService.user_dept;                 
        //         }
        //     });
        // }

        // console.log(user_role);
        // if(route.data.page=='main-dashboard' && this.authService.isLoggedIn())
        // {
        //     // authorised so return true
        //     return true;
        // }
        
        // console.log(user_role);
        // if (user_role) {
        //     // check if route is restricted by role
        //     if (route.data.roles && route.data.roles.indexOf(user_role) === -1) {
        //         // role not authorised so redirect to home page
        //         //this.router.navigate(['/']);
        //         this.notificationService.warn('Permission Denied!!');
        //         return false;
        //     }
        //     // authorised so return true
        //     return true;
        // }
        // else if(this.authService.isLoggedIn()) {
        //     // Validate Token on refresh         
        //     this.authService.validate_token().subscribe(data=> {
        //         console.log(data);
        //         if(data['status']) {
        //             this.authService.bindNavbar(data['user']);
        //             // redirect to refresh url 
        //             this.router.navigate([state.url]);
        //             return true;               
        //         }
        //         else {
        //             // not logged in so redirect to login page with the return url
        //             this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        //             return false;
        //         }
        //     });
        // }
        // else
        // {
        //     // not logged in so redirect to login page with the return url
        //     this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        //     return false;
        // }
    }
}